var NotificationPopUpModule = /** @class */ (function () {
    function NotificationPopUpModule() {
    }
    return NotificationPopUpModule;
}());
export { NotificationPopUpModule };
